const FIRST_ID = 0;

export default function first(arr) {
   return arr[FIRST_ID];
}
